<template>
  <span>{{ value }}</span>
</template>

<script>
export default {
  props: {
    settings: {
      type: Object,
      default: {
        showFullNumber: false
      },
    },
    data: {
      type: Object,
      default: {
        form_data: null
      },
      required: false
    }
  },
  computed: {
    value: function () {
      if (this.data && this.data.td) {
        if (this.settings.showFullNumber) {
          return this.data.td;
        } else {
          return '*****' + this.data.td.slice(-4)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// SsnReportField.vue?2c5fc3c8